<template>
  <div>
    <v-container>
      <h2>Filtro asociado</h2>
      <v-row>
        <!-- {{ this.pages[selectedPage] }} -->
        <!-- {{ this.pages[selectedPage].item_list }} -->
        <v-select
          :items="filtrosRelacionados"
          item-text="name"
          label="Select an Item"
          v-model="selectedItem.customized.filtroAsociado"
          return-object
        ></v-select>
        <!-- </v-col> -->
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["selectedItem", "pages", "selectedPage"]),

    filtrosRelacionados() {
      return this.pages[this.selectedPage].item_list.filter((el) => {
        return el.settings.component_name === "filtro-entre-fechas";
      });
    },
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
